import styled from 'styled-components';

export const InfoContainer = styled.div`
  width: 200px;
  padding: 16px;
`;
